import { makeStyles } from '@material-ui/styles'

export const splashScreenStyle = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    height: '50%',
    width: '50%,',
  },
})
